import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as gameOTPActions from '../../../actions/gameOTP';
import { STATUS_CODE } from '../../../constants';
import Authenticator from '../main_panel/Authenticator';
import Mobile from '../main_panel/Mobile';

class SaveGameOTP extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			game_id: null,
			game_status: null
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.saveGameOTP(this.getGameID(), this.getGameStatus());
	}

	handleChangeGame(game_id) {
		let games = this.getGames();
		this.setState({
			game_id: game_id,
			game_staus: games[game_id].status
		});
	}

	handleChangeGameStatus(event) {
		let game_status = event.target.checked ? 1 : 0;
		this.setState({game_status: game_status});
	}

	getGames() {
		return this.props.gameOtpConfigs[this.props.language.country];
	}

	getGameID() {
		let games = this.getGames();
		let game_id = this.state.game_id === null ? Object.keys(games)[0] : this.state.game_id;
		return game_id
	}

	getGame() {
		let games = this.getGames();
		let game_id = this.getGameID();
		return games[game_id];
	}

	getGameStatus() {
		let game = this.getGame();
		return this.state.game_status === null ? game.status : this.state.game_status;
	}

	getAuthenticatorAvailable() {
		let game = this.getGame();
		return this.props.userInfo.authenticator_enable && game.authenticator_available;
	}

	getSMSAvailable() {
		let game = this.getGame();
		return this.props.userInfo.mobile_no && game.sms_available;
	}

	getActivatedAvailableChannelExist() {
		let game = this.getGame();
		return this.getAuthenticatorAvailable() || this.getSMSAvailable();
	}

	renderGameOption(game_id, isActive) {
		return (
			<a href="#" className={isActive ? "hd-lang__select-item hd-lang__select-item--cur" : "hd-lang__select-item"}
				key={game_id} onClick={() => this.handleChangeGame(game_id)}>
				{this.getGames()[game_id].name}
			</a>
		);
	}

	renderActiveGame() {
		return (
			<a href="javascript:;" className="hd-lang__cur">
				<div className="hd-lang__cur-txt">
					{this.getGame().name}
				</div>
			</a>
		);
	}

	renderGameList() {
		var gameList = [];
		for (var game_id in this.getGames()) {
			var isActive = (game_id === this.getGameID());
			var gameOption = this.renderGameOption(game_id, isActive);
			gameList.push(gameOption);
		}
		return (
			<div className="hd-lang__select">
				{gameList}
			</div>
		);
	}

	renderGameComponent() {
		return (
			<div className="hd-lang">
				{this.renderActiveGame()}
				{ Object.keys(this.getGames()).length > 1 ? this.renderGameList(): null }
			</div>
		);
	}

	render() {

		if (this.props.gameOtpConfigs === null) {
			return null;
		}

		return (
			<div className="content">

				<div className="content-item content-item--ipage">

					<div className="content-item__title">
						{ trans('change_game_otp_title') }
					</div>

					<div className="content-item__main">

						<div className="content-item--ipage__main">
						    <div className="content__sendinfo" id="J-sendinfo">
                                {trans('select_game_otp')}
							</div>

							<div>
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>

									<div className="content__form-input">
									    {this.renderGameComponent()}
									</div>

									{this.getGame().authenticator_available? <Authenticator /> : null}
									{this.getGame().sms_available? <Mobile /> : null}
									
									<div className="content__form-input">
										<div className={ `content__form-checkbox ${!this.getActivatedAvailableChannelExist() ? "content__form-checkbox-disabled" : "" }`}>
											<input type="checkbox" className="J-validated-field"
												id="game_otp_checkbox"
												disabled={!this.getActivatedAvailableChannelExist()}
												checked={this.getGameStatus()}
												onChange={this.handleChangeGameStatus.bind(this)} />
											<label htmlFor="game_otp_checkbox"></label>
										</div> <label>{ trans('change_game_otp_status_checkbox') }</label>
									</div>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" 
											disabled={this.getGame().status === this.getGameStatus()}
											value={trans('confirm_btn')}/>
									</div>
								</form>
							</div>
						</div>
					</div>

				</div>

			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
	    gameOtpConfigs: state.data.gameOtpConfigs,
	    userInfo: state.data.userInfo,
	    language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, gameOTPActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveGameOTP);


// WEBPACK FOOTER //
// ./app/components/security/game_otp/SaveGameOTP.js